import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getGPSSensorList } from '../../actions/hardware';
import ReactHighcharts from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsNoData from 'highcharts/modules/no-data-to-display';
import moment from 'moment';
import { DISPLAY_TIME_FORMAT } from '../../constants';

HighchartsNoData(Highcharts);

const GpsDataGraph = (props) => {
    const { isRequesting, egId, deviceId, sensorData, hardwareId, actions } = props;
    const [chart, setChart] = useState(null);

    const chartOptions = {
        chart: {
            zoomType: 'x',
            events: {
                load: function () {
                    setChart(this)
                }
            }
        },
        title: {
            text: ''
        },
        subtitle: {
            text: document.ontouchstart === undefined ?
                'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
        },
        xAxis: {
            type: 'datetime',
            labels: {
                rotation: -33,
                style: {
                    fontSize: '0.65rem'
                },
                format: "{value:%I %p}",
                formatter: function () {
                    const diff = (this.axis.dataMax - this.axis.dataMin) / (24 * 3600 * 1000);
                    return (diff === 1) ? this.axis.defaultLabelFormatter.call(this) : Highcharts.dateFormat('%e %b %I %p', this.value);
                }
            }
        },
        yAxis: {
            title: {
                text: 'GPS data count'
            }
        },
        legend: {
            enabled: false
        },
        lang: {
            loading: "Loading...",
            noData: "No data found"
        },
        noData: {
            style: {
                fontSize: '15px',
                color: '#aca7a7'
            }
        },
        loading: {
            style: {
                fontSize: '15px',
                color: '#2a2929',
                marginTop: "25px"
            }
        },
        tooltip: {
            enabled: true,
            pointFormat: '<span>{point.dateRange}</span>' +
                '<br><span>Count</span>: <b>{point.y}</b><br />'
        },
        series: [{
            name: 'Data count',
            data: []
        }]
    };

    const getChartOptions = (data = []) => {
        const gpsData = data.reduce((listById, item) => {
            const ts = parseInt(item.ts);
            const value = moment.utc(ts).startOf("hour");
            listById[value] = (listById[value] || []).concat(item);
            return listById;
        }, {});

        const dataList = [];
        Object.keys(gpsData).forEach(id => {
            dataList.push({
                x: moment.utc(id).valueOf(),
                y: gpsData[id].length,
                dateRange: `${moment.utc(id).subtract(1, "hour").format(DISPLAY_TIME_FORMAT)} - ${moment.utc(id).format(DISPLAY_TIME_FORMAT)}`
            })
        })

        return ({
            ...chartOptions,
            series: [{
                name: 'Data count',
                data: dataList
            }]
        })
    };

    const getFiltereSensorData = () => {
        if (sensorData && sensorData[egId] && sensorData[egId].data) {
            return sensorData[egId].data.filter(item => item.device_uuid === deviceId)
        } else return [];
    }

    const data = useMemo(getFiltereSensorData, [sensorData, egId]);
    const options = useMemo(() => getChartOptions(data), [data]);

    useEffect(() => {
        if (hardwareId && egId && !sensorData) {
            const egIds = [egId]
            actions.getGPSSensorList(hardwareId, egIds)
        }
    }, [hardwareId, egId]);

    useEffect(() => {
        if (!chart || !chart.series) return;
        if (isRequesting) {
            chart.series[0].remove(true);
            chart.hideNoData();
            chart.showLoading();
        } else {
            if (data && data.length === 0) chart.showNoData();
        }
    }, [isRequesting, data, chart]);

    return <ReactHighcharts immutable={true} highcharts={Highcharts} options={options} />
}

const mapStateToProps = (state, { hardwareId }) => {
    const sensorData = state.hardware.gpsSensorDataById[`${hardwareId}`]
        ? state.hardware.gpsSensorDataById[`${hardwareId}`] : null;
    return {
        isRequesting: sensorData ? sensorData.isRequesting : false,
        sensorData: sensorData ? sensorData.payload : null
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getGPSSensorList }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(GpsDataGraph);